<template>
  <!-- 和SearchCondition一样的样式，但只有样式没有代码 -->
  <div class="detail-form" :style="{'--status-color': statusColor}">
    <div class="common">
      <slot />
    </div>
    <div class="append">
      <slot name="append"/>
    </div>
    <div class="status" v-if="showStatus">
      <slot name="status"/>
    </div>
  </div>

</template>

<script>
import {getCurrentInstance} from "vue";
export default {
  props: {
    miniShowCount: {default: 3},
    statusColor: {default: "#67C23A"},
    showStatus: {default: false},
  },
  name: "DF",
  components: {
  },
  data() {
    return {
      showMoreInfo: false, // 是否显示更多信息
      hasMoreInfo: false, // 是否有更多信息，有更多信息时才显示showMoreInfo的按钮
    };
  },
  created() {
    const ins = getCurrentInstance();
    if (ins) {
      const slotContent = ins.slots.default();
      // 有对应的对象
      if (slotContent.length > this.miniShowCount) {
        this.hasMoreInfo = true;
      }
    }
  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.detail-form{
  --single-width: 240px; // 单倍宽度
  position: relative;
  .common{
    >div,>span{
      line-height: 36px;
    }
    :deep(>*){
      max-width: var(--single-width);
      margin-right: 10px;
      margin-left: 0;
      margin-bottom: 10px;
      display: inline-block !important;
      vertical-align: top;
      height: 36px;
      overflow: hidden;
      .el-input__wrapper{
        box-sizing: border-box;
        width: 100%;
        .el-input__prefix{
          margin-right: 8px;
          color: #333;
          .el-input__prefix-inner::after{
            content: ":";
          }
        }
      }
      .el-select__prefix{
        color: #333;
      }
      &:last-child{
        margin-right: 0;
      }
      &.float{
        float: right;
        white-space: nowrap;
        overflow: hidden;
        max-width: none;
      }
    }
  }
  .append{
    padding-bottom: 10px;
  }
  .status{
    position: absolute;
    right: 10px;
    top: 10px;
    padding: 4px 10px;
    border: 2px solid var(--status-color);
    color: var(--status-color);
    border-radius: 4px;
    rotate: 345deg;
    opacity: .6;
  }
}
</style>